import {Directive, ViewContainerRef} from '@angular/core';

@Directive({standalone: true, selector: '[pubAttachmentRender]'})
export class AttachmentRenderDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
